var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t) {
  "function" == typeof define && define.amd ? define(t) : t();
}(function () {
  "use strict";

  var _ot;

  function t() {}

  function e(t) {
    return t();
  }

  function n() {
    return Object.create(null);
  }

  function o(t) {
    t.forEach(e);
  }

  function i(t) {
    return "function" == typeof t;
  }

  function r(t, e) {
    return t != t ? e == e : t !== e || t && "object" == typeof t || "function" == typeof t;
  }

  function s(t, e) {
    return t != t ? e == e : t !== e;
  }

  function c(t) {
    return 0 === Object.keys(t).length;
  }

  function a(t, e) {
    t.appendChild(e);
  }

  function l(t, e, n) {
    var o = function (t) {
      if (!t) return document;
      var e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
      if (e && e.host) return e;
      return t.ownerDocument;
    }(t);

    if (!o.getElementById(e)) {
      var _t = f("style");

      _t.id = e, _t.textContent = n, function (t, e) {
        a(t.head || t, e);
      }(o, _t);
    }
  }

  function d(t, e, n) {
    t.insertBefore(e, n || null);
  }

  function u(t) {
    t.parentNode.removeChild(t);
  }

  function f(t) {
    return document.createElement(t);
  }

  function h(t) {
    return document.createElementNS("http://www.w3.org/2000/svg", t);
  }

  function p(t) {
    return document.createTextNode(t);
  }

  function g() {
    return p(" ");
  }

  function $(t, e, n, o) {
    return t.addEventListener(e, n, o), function () {
      return t.removeEventListener(e, n, o);
    };
  }

  function m(t, e, n) {
    null == n ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
  }

  function v(t, e, n, o) {
    t.style.setProperty(e, n, o ? "important" : "");
  }

  function x(t, e, n) {
    t.classList[n ? "add" : "remove"](e);
  }

  function w(t) {
    var e = {};

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        e[_n.name] = _n.value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  }

  var b;

  function y(t) {
    b = t;
  }

  function k() {
    if (!b) throw new Error("Function called outside component initialization");
    return b;
  }

  var z = [],
      E = [],
      M = [],
      _ = [],
      C = Promise.resolve();
  var N = !1;

  function D(t) {
    M.push(t);
  }

  var B = !1;
  var F = new Set();

  function S() {
    if (!B) {
      B = !0;

      do {
        for (var _t2 = 0; _t2 < z.length; _t2 += 1) {
          var _e = z[_t2];
          y(_e), L(_e.$$);
        }

        for (y(null), z.length = 0; E.length;) {
          E.pop()();
        }

        for (var _t3 = 0; _t3 < M.length; _t3 += 1) {
          var _e2 = M[_t3];
          F.has(_e2) || (F.add(_e2), _e2());
        }

        M.length = 0;
      } while (z.length);

      for (; _.length;) {
        _.pop()();
      }

      N = !1, B = !1, F.clear();
    }
  }

  function L(t) {
    if (null !== t.fragment) {
      t.update(), o(t.before_update);
      var _e3 = t.dirty;
      t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, _e3), t.after_update.forEach(D);
    }
  }

  var A = new Set();

  function R(t, e) {
    t && t.i && (A.delete(t), t.i(e));
  }

  function I(t, e, n, o) {
    if (t && t.o) {
      if (A.has(t)) return;
      A.add(t), undefined.c.push(function () {
        A.delete(t), o && (n && t.d(1), o());
      }), t.o(e);
    }
  }

  var P = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;

  function T(t) {
    t && t.c();
  }

  function V(t, n, r, s) {
    var _t$$$ = t.$$,
        c = _t$$$.fragment,
        a = _t$$$.on_mount,
        l = _t$$$.on_destroy,
        d = _t$$$.after_update;
    c && c.m(n, r), s || D(function () {
      var n = a.map(e).filter(i);
      l ? l.push.apply(l, _toConsumableArray(n)) : o(n), t.$$.on_mount = [];
    }), d.forEach(D);
  }

  function G(t, e) {
    var n = t.$$;
    null !== n.fragment && (o(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
  }

  function H(t, e) {
    -1 === t.$$.dirty[0] && (z.push(t), N || (N = !0, C.then(S)), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
  }

  function j(e, i, r, s, c, a, l) {
    var d = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1];
    var f = b;
    y(e);
    var h = e.$$ = {
      fragment: null,
      ctx: null,
      props: a,
      update: t,
      not_equal: c,
      bound: n(),
      on_mount: [],
      on_destroy: [],
      on_disconnect: [],
      before_update: [],
      after_update: [],
      context: new Map(i.context || (f ? f.$$.context : [])),
      callbacks: n(),
      dirty: d,
      skip_bound: !1,
      root: i.target || f.$$.root
    };
    l && l(h.root);
    var p = !1;

    if (h.ctx = r ? r(e, i.props || {}, function (t, n) {
      var i = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : n;
      return h.ctx && c(h.ctx[t], h.ctx[t] = i) && (!h.skip_bound && h.bound[t] && h.bound[t](i), p && H(e, t)), n;
    }) : [], h.update(), p = !0, o(h.before_update), h.fragment = !!s && s(h.ctx), i.target) {
      if (i.hydrate) {
        var _t4 = function (t) {
          return Array.from(t.childNodes);
        }(i.target);

        h.fragment && h.fragment.l(_t4), _t4.forEach(u);
      } else h.fragment && h.fragment.c();

      i.intro && R(e.$$.fragment), V(e, i.target, i.anchor, i.customElement), S();
    }

    y(f);
  }

  var O;
  "function" == typeof HTMLElement && (O = /*#__PURE__*/function (_HTMLElement) {
    _inherits(O, _HTMLElement);

    function O() {
      var _this;

      _classCallCheck(this, O);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(O).call(this)), _this.attachShadow({
        mode: "open"
      });
      return _this;
    }

    _createClass(O, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var t = this.$$.on_mount;
        this.$$.on_disconnect = t.map(e).filter(i);

        for (var _t5 in this.$$.slotted) {
          this.appendChild(this.$$.slotted[_t5]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(t, e, n) {
        this[t] = n;
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        o(this.$$.on_disconnect);
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        G(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        this.$$set && !c(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return O;
  }(_wrapNativeSuper(HTMLElement)));

  var U = /*#__PURE__*/function () {
    function U() {
      _classCallCheck(this, U);
    }

    _createClass(U, [{
      key: "$destroy",
      value: function $destroy() {
        G(this, 1), this.$destroy = t;
      }
    }, {
      key: "$on",
      value: function $on(t, e) {
        var n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return n.push(e), function () {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set(t) {
        this.$$set && !c(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
      }
    }]);

    return U;
  }();

  function q(t) {
    l(t, "svelte-1mwhwtl", ".Frame.svelte-1mwhwtl{position:absolute;width:100%;height:100%;top:50%;left:50%;transform-origin:50% 50%;transform:translate(-50%, -50%) rotate(var(--fx-rotation));transition:width 0.1s, height 0.1s;pointer-events:none;user-select:none}");
  }

  function W(e) {
    var n, o, i, r, s, _c, l;

    return {
      c: function c() {
        n = h("svg"), o = h("defs"), i = h("linearGradient"), r = h("stop"), s = h("stop"), _c = h("circle"), l = h("circle"), m(r, "stop-color", "var(--gradient-stop1)"), m(r, "offset", "0%"), m(s, "stop-color", "var(--gradient-stop2)"), m(s, "offset", "100%"), m(i, "x1", "50%"), m(i, "y1", "0%"), m(i, "x2", "50%"), m(i, "y2", "100%"), m(i, "id", "a"), m(_c, "cx", "46"), m(_c, "cy", "46"), m(_c, "r", e[0]), m(_c, "stroke", "none"), m(_c, "fill", "var(--frame-background)"), m(l, "cx", "46"), m(l, "cy", "46"), m(l, "r", e[0]), m(l, "stroke", "url(#a)"), m(l, "stroke-width", "var(--frame-stroke-width)"), m(l, "fill", "none"), m(n, "class", "Frame svelte-1mwhwtl"), m(n, "viewBox", "0 0 92 92"), m(n, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, e) {
        d(t, n, e), a(n, o), a(o, i), a(i, r), a(i, s), a(n, _c), a(n, l);
      },
      p: function p(t, _ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            e = _ref2[0];

        1 & e && m(_c, "r", t[0]), 1 & e && m(l, "r", t[0]);
      },
      i: t,
      o: t,
      d: function d(t) {
        t && u(n);
      }
    };
  }

  function J(t, e, n) {
    var _e$frameRadius = e.frameRadius,
        o = _e$frameRadius === void 0 ? 46 : _e$frameRadius;
    return t.$$set = function (t) {
      "frameRadius" in t && n(0, o = t.frameRadius);
    }, [o];
  }

  var K = /*#__PURE__*/function (_U) {
    _inherits(K, _U);

    function K(t) {
      var _this2;

      _classCallCheck(this, K);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(K).call(this)), j(_assertThisInitialized(_assertThisInitialized(_this2)), t, J, W, r, {
        frameRadius: 0
      }, q);
      return _this2;
    }

    return K;
  }(U);

  var Q, X, Y, Z, tt, et, nt;
  !function (t) {
    t[t.Failed = 0] = "Failed", t[t.NoBrowserSupport = 1] = "NoBrowserSupport", t[t.NoAudioConsent = 2] = "NoAudioConsent", t[t.__UnrecoverableErrors = 3] = "__UnrecoverableErrors", t[t.Disconnected = 4] = "Disconnected", t[t.Disconnecting = 5] = "Disconnecting", t[t.Connecting = 6] = "Connecting", t[t.Preinitialized = 7] = "Preinitialized", t[t.Initializing = 8] = "Initializing", t[t.Connected = 9] = "Connected", t[t.Stopping = 10] = "Stopping", t[t.Starting = 11] = "Starting", t[t.Recording = 12] = "Recording";
  }(Q || (Q = {})), function (t) {
    t.SpeechlyFirstConnect = "SpeechlyFirstConnect";
  }(X || (X = {})), function (t) {
    t.speechlypoweron = "speechlypoweron", t.holdstart = "holdstart", t.holdend = "holdend", t.speechstate = "speechstate", t.speechsegment = "speechsegment", t.speechhandled = "speechhandled", t.showhint = "showhint", t.transcriptdrawerhint = "hint", t.speechlyintroready = "speechlyintroready", t.speechlyintroclosed = "speechlyintroclosed";
  }(Y || (Y = {})), function (t) {
    t.Mic = "mic", t.MicActive = "micactive", t.Error = "error", t.Denied = "denied";
  }(Z || (Z = {})), function (t) {
    t.Hold = "hold", t.Click = "click", t.Noninteractive = "noninteractive";
  }(tt || (tt = {})), function (t) {
    t.None = "none", t.Connecting = "connecting", t.Busy = "busy";
  }(et || (et = {})), function (t) {
    t.None = "none", t.Whirl = "whirl";
  }(nt || (nt = {}));
  var ot = (_ot = {}, _defineProperty(_ot, Q.Disconnected, {
    icon: "mic",
    behaviour: "click",
    effect: "none",
    triggerFx: "whirl"
  }), _defineProperty(_ot, Q.Disconnecting, {
    icon: "mic",
    behaviour: "noninteractive",
    effect: "connecting"
  }), _defineProperty(_ot, Q.Connecting, {
    icon: "mic",
    behaviour: "noninteractive",
    effect: "connecting"
  }), _defineProperty(_ot, Q.Preinitialized, {
    icon: "mic",
    behaviour: "hold",
    effect: "none",
    triggerFx: "whirl"
  }), _defineProperty(_ot, Q.Initializing, {
    icon: "mic",
    behaviour: "noninteractive",
    effect: "connecting"
  }), _defineProperty(_ot, Q.Connected, {
    icon: "mic",
    behaviour: "hold",
    effect: "none",
    triggerFx: "whirl"
  }), _defineProperty(_ot, Q.Starting, {
    icon: "mic",
    behaviour: "hold",
    effect: "connecting"
  }), _defineProperty(_ot, Q.Recording, {
    icon: "micactive",
    behaviour: "hold",
    effect: "none"
  }), _defineProperty(_ot, Q.Stopping, {
    icon: "mic",
    behaviour: "noninteractive",
    effect: "busy"
  }), _defineProperty(_ot, Q.Failed, {
    icon: "error",
    behaviour: "click",
    effect: "none"
  }), _defineProperty(_ot, Q.NoBrowserSupport, {
    icon: "error",
    behaviour: "click",
    effect: "none"
  }), _defineProperty(_ot, Q.NoAudioConsent, {
    icon: "denied",
    behaviour: "click",
    effect: "none"
  }), _ot);

  function it(t) {
    l(t, "svelte-s2u2hd", ".Icon.svelte-s2u2hd{position:absolute;width:var(--icon-size);height:var(--icon-size);top:50%;left:50%;transform:translate(-50%, -50%);pointer-events:none;transition:0.25s;opacity:var(--icon-opacity)}");
  }

  function rt(t) {
    var e, n, o, i, r, s, _c2, l, f, g, $, v, x;

    return {
      c: function c() {
        e = h("svg"), n = h("linearGradient"), o = h("animate"), i = h("animate"), r = h("stop"), s = h("stop"), _c2 = h("stop"), l = h("stop"), f = h("stop"), g = p(">\n  "), $ = h("g"), v = h("path"), x = h("rect"), m(o, "attributeName", "y1"), m(o, "values", "-200%; 0%;"), m(o, "dur", "2s"), m(o, "repeatCount", "indefinite"), m(i, "attributeName", "y2"), m(i, "values", "200%; 400%;"), m(i, "dur", "2s"), m(i, "repeatCount", "indefinite"), m(r, "offset", "0%"), m(r, "stop-color", "var(--gradient-stop1)"), m(s, "offset", "25%"), m(s, "stop-color", "var(--gradient-stop2)"), m(_c2, "offset", "50%"), m(_c2, "stop-color", "var(--gradient-stop1)"), m(l, "offset", "75%"), m(l, "stop-color", "var(--gradient-stop2)"), m(f, "offset", "100%"), m(f, "stop-color", "var(--gradient-stop1)"), m(n, "id", "gradient"), m(n, "x1", "50%"), m(n, "y1", "-200%"), m(n, "x2", "50%"), m(n, "y2", "200%"), m(v, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), m(x, "x", "20"), m(x, "y", "1"), m(x, "width", "16"), m(x, "height", "37"), m(x, "rx", "8"), m($, "fill", "url(#gradient)"), m($, "fill-rule", "evenodd"), m(e, "class", "Icon svelte-s2u2hd"), m(e, "viewBox", "0 0 56 56"), m(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, u) {
        d(t, e, u), a(e, n), a(n, o), a(n, i), a(n, r), a(n, s), a(n, _c2), a(n, l), a(n, f), a(e, g), a(e, $), a($, v), a($, x);
      },
      d: function d(t) {
        t && u(e);
      }
    };
  }

  function st(t) {
    var e, n, o, i;
    return {
      c: function c() {
        e = h("svg"), n = h("g"), o = h("path"), i = h("rect"), m(o, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), m(i, "x", "20"), m(i, "y", "1"), m(i, "width", "16"), m(i, "height", "37"), m(i, "rx", "8"), m(n, "fill", "var(--icon-color)"), m(n, "fill-rule", "evenodd"), m(e, "class", "Icon svelte-s2u2hd"), m(e, "viewBox", "0 0 56 56"), m(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, r) {
        d(t, e, r), a(e, n), a(n, o), a(n, i);
      },
      d: function d(t) {
        t && u(e);
      }
    };
  }

  function ct(t) {
    var e, n, o, i;
    return {
      c: function c() {
        e = h("svg"), n = h("g"), o = h("path"), i = h("path"), m(o, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), m(o, "fill-rule", "nonzero"), m(i, "d", "M37 13.081V31a8 8 0 11-16 0v-1.919l16-16zM26 1a8 8 0 018 8v1.319L18 26.318V9a8 8 0 018-8zM37.969 7.932l3.74-7.35 3.018 2.625zM39.654 10.608l7.531-3.359.695 3.94z"), m(n, "fill", "var(--icon-color)"), m(n, "fill-rule", "evenodd"), m(e, "class", "Icon svelte-s2u2hd"), m(e, "viewBox", "0 0 56 56"), m(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, r) {
        d(t, e, r), a(e, n), a(n, o), a(n, i);
      },
      d: function d(t) {
        t && u(e);
      }
    };
  }

  function at(t) {
    var e, n, o, i;
    return {
      c: function c() {
        e = h("svg"), n = h("g"), o = h("path"), i = h("path"), m(o, "d", "M36 14.828V30a8 8 0 01-15.961.79l15.96-15.962zM28 1a8 8 0 018 8v.172L20 25.173V9a8 8 0 018-8z"), m(i, "d", "M42 26h4v4c0 9.265-7 16.895-16 17.89V55h-4v-7.11c-8.892-.982-15.833-8.444-15.997-17.56L10 30v-4h4v4c0 7.732 6.268 14 14 14 7.628 0 13.83-6.1 13.997-13.687L42 30v-4z"), m(n, "fill", "var(--icon-color)"), m(n, "fill-rule", "nonzero"), m(e, "class", "Icon svelte-s2u2hd"), m(e, "viewBox", "0 0 56 56"), m(e, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, r) {
        d(t, e, r), a(e, n), a(n, o), a(n, i);
      },
      d: function d(t) {
        t && u(e);
      }
    };
  }

  function lt(e) {
    var n,
        o,
        i,
        r,
        s = e[0] === Z.MicActive && rt(),
        _c3 = e[0] === Z.Mic && st(),
        a = e[0] === Z.Error && ct(),
        l = e[0] === Z.Denied && at();

    return {
      c: function c() {
        s && s.c(), n = g(), _c3 && _c3.c(), o = g(), a && a.c(), i = g(), l && l.c(), r = p("");
      },
      m: function m(t, e) {
        s && s.m(t, e), d(t, n, e), _c3 && _c3.m(t, e), d(t, o, e), a && a.m(t, e), d(t, i, e), l && l.m(t, e), d(t, r, e);
      },
      p: function p(t, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            e = _ref4[0];

        t[0] === Z.MicActive ? s || (s = rt(), s.c(), s.m(n.parentNode, n)) : s && (s.d(1), s = null), t[0] === Z.Mic ? _c3 || (_c3 = st(), _c3.c(), _c3.m(o.parentNode, o)) : _c3 && (_c3.d(1), _c3 = null), t[0] === Z.Error ? a || (a = ct(), a.c(), a.m(i.parentNode, i)) : a && (a.d(1), a = null), t[0] === Z.Denied ? l || (l = at(), l.c(), l.m(r.parentNode, r)) : l && (l.d(1), l = null);
      },
      i: t,
      o: t,
      d: function d(t) {
        s && s.d(t), t && u(n), _c3 && _c3.d(t), t && u(o), a && a.d(t), t && u(i), l && l.d(t), t && u(r);
      }
    };
  }

  function dt(t, e, n) {
    var _e$icon = e.icon,
        o = _e$icon === void 0 ? Z.Mic : _e$icon;
    return t.$$set = function (t) {
      "icon" in t && n(0, o = t.icon);
    }, [o];
  }

  var ut = /*#__PURE__*/function (_U2) {
    _inherits(ut, _U2);

    function ut(t) {
      var _this3;

      _classCallCheck(this, ut);

      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ut).call(this)), j(_assertThisInitialized(_assertThisInitialized(_this3)), t, dt, lt, r, {
        icon: 0
      }, it);
      return _this3;
    }

    return ut;
  }(U);

  function ft(t) {
    l(t, "svelte-1fpkb0k", ".Fx.svelte-1fpkb0k{position:absolute;width:var(--fx-size);height:var(--fx-size);top:50%;left:50%;transform-origin:50% 50%;transform:translate(-50%, -50%) rotate(var(--fx-rotation));pointer-events:none;opacity:var(--fx-opacity)}");
  }

  function ht(e) {
    var n, o, i, r, s, _c4, l, f;

    return {
      c: function c() {
        n = h("svg"), o = h("defs"), i = h("linearGradient"), r = h("stop"), s = h("stop"), _c4 = h("filter"), l = h("feGaussianBlur"), f = h("circle"), m(r, "stop-color", "var(--fx-gradient-stop1)"), m(r, "offset", "0%"), m(s, "stop-color", "var(--fx-gradient-stop2)"), m(s, "offset", "100%"), m(i, "x1", "50%"), m(i, "y1", "10%"), m(i, "x2", "50%"), m(i, "y2", "100%"), m(i, "id", "a"), m(l, "stdDeviation", "18"), m(l, "in", "SourceGraphic"), m(_c4, "x", "-35%"), m(_c4, "y", "-35%"), m(_c4, "width", "170%"), m(_c4, "height", "170%"), m(_c4, "filterUnits", "objectBoundingBox"), m(_c4, "id", "b"), m(f, "filter", "url(#b)"), m(f, "cx", "124"), m(f, "cy", "124"), m(f, "r", "79"), m(f, "fill", "url(#a)"), m(f, "fillrule", "evenodd"), m(n, "class", "Fx svelte-1fpkb0k"), m(n, "viewBox", "0 0 246 246"), m(n, "xmlns", "http://www.w3.org/2000/svg");
      },
      m: function m(t, e) {
        d(t, n, e), a(n, o), a(o, i), a(i, r), a(i, s), a(o, _c4), a(_c4, l), a(n, f);
      },
      p: t,
      i: t,
      o: t,
      d: function d(t) {
        t && u(n);
      }
    };
  }

  var pt = /*#__PURE__*/function (_U3) {
    _inherits(pt, _U3);

    function pt(t) {
      var _this4;

      _classCallCheck(this, pt);

      _this4 = _possibleConstructorReturn(this, _getPrototypeOf(pt).call(this)), j(_assertThisInitialized(_assertThisInitialized(_this4)), t, null, ht, r, {}, ft);
      return _this4;
    }

    return pt;
  }(U);

  var gt = P.window;

  function $t(t) {
    var e;
    return {
      c: function c() {
        e = f("link"), m(e, "href", t[9]), m(e, "rel", "stylesheet");
      },
      m: function m(t, n) {
        d(t, e, n);
      },
      p: function p(t, n) {
        512 & n[0] && m(e, "href", t[9]);
      },
      d: function d(t) {
        t && u(e);
      }
    };
  }

  function mt(e) {
    var n,
        i,
        r,
        s,
        _c5,
        l,
        h,
        p,
        w,
        b,
        y,
        k,
        z = void 0 !== e[9] && $t(e);

    return r = new pt({}), _c5 = new K({
      props: {
        frameRadius: e[16]
      }
    }), h = new ut({
      props: {
        icon: e[15].icon
      }
    }), {
      c: function c() {
        z && z.c(), n = g(), i = f("main"), T(r.$$.fragment), s = g(), T(_c5.$$.fragment), l = g(), T(h.$$.fragment), p = g(), w = f("slot"), this.c = t, m(i, "class", "HoldableButton"), v(i, "width", e[0]), v(i, "height", e[0]), v(i, "--gradient-stop1", e[5]), v(i, "--gradient-stop2", e[6]), v(i, "--fx-gradient-stop1", e[7] || e[5]), v(i, "--fx-gradient-stop2", e[8] || e[6]), v(i, "--fx-rotation", e[11][1] + "deg"), v(i, "--fx-opacity", e[14][1]), v(i, "--fx-size", e[2]), v(i, "--icon-opacity", e[13][1]), v(i, "--icon-size", e[1]), v(i, "--icon-color", e[4]), v(i, "--frame-stroke-width", e[17]), v(i, "--frame-background", e[3]), v(i, "transform", "scale(" + e[12][1] + ")"), x(i, "pressed", e[10]);
      },
      m: function m(t, o) {
        z && z.m(t, o), d(t, n, o), d(t, i, o), V(r, i, null), a(i, s), V(_c5, i, null), a(i, l), V(h, i, null), a(i, p), a(i, w), b = !0, y || (k = [$(gt, "mouseup", e[19]), $(gt, "keydown", e[20]), $(gt, "keyup", e[21]), $(i, "mousedown", e[18]), $(i, "touchstart", e[18]), $(i, "dragstart", e[18]), $(i, "mouseup", e[19]), $(i, "touchend", e[19], {
          passive: !0
        }), $(i, "dragend", e[19])], y = !0);
      },
      p: function p(t, e) {
        void 0 !== t[9] ? z ? z.p(t, e) : (z = $t(t), z.c(), z.m(n.parentNode, n)) : z && (z.d(1), z = null);
        var o = {};
        65536 & e[0] && (o.frameRadius = t[16]), _c5.$set(o);
        var r = {};
        32768 & e[0] && (r.icon = t[15].icon), h.$set(r), (!b || 1 & e[0]) && v(i, "width", t[0]), (!b || 1 & e[0]) && v(i, "height", t[0]), (!b || 32 & e[0]) && v(i, "--gradient-stop1", t[5]), (!b || 64 & e[0]) && v(i, "--gradient-stop2", t[6]), (!b || 160 & e[0]) && v(i, "--fx-gradient-stop1", t[7] || t[5]), (!b || 320 & e[0]) && v(i, "--fx-gradient-stop2", t[8] || t[6]), (!b || 2048 & e[0]) && v(i, "--fx-rotation", t[11][1] + "deg"), (!b || 16384 & e[0]) && v(i, "--fx-opacity", t[14][1]), (!b || 4 & e[0]) && v(i, "--fx-size", t[2]), (!b || 8192 & e[0]) && v(i, "--icon-opacity", t[13][1]), (!b || 2 & e[0]) && v(i, "--icon-size", t[1]), (!b || 16 & e[0]) && v(i, "--icon-color", t[4]), (!b || 131072 & e[0]) && v(i, "--frame-stroke-width", t[17]), (!b || 8 & e[0]) && v(i, "--frame-background", t[3]), (!b || 4096 & e[0]) && v(i, "transform", "scale(" + t[12][1] + ")"), 1024 & e[0] && x(i, "pressed", t[10]);
      },
      i: function i(t) {
        b || (R(r.$$.fragment, t), R(_c5.$$.fragment, t), R(h.$$.fragment, t), b = !0);
      },
      o: function o(t) {
        I(r.$$.fragment, t), I(_c5.$$.fragment, t), I(h.$$.fragment, t), b = !1;
      },
      d: function d(t) {
        z && z.d(t), t && u(n), t && u(i), G(r), G(_c5), G(h), y = !1, o(k);
      }
    };
  }

  function vt(t, e, n) {
    var o,
        i,
        r,
        s,
        _e$icon2 = e.icon,
        c = _e$icon2 === void 0 ? Q.Disconnected : _e$icon2,
        _e$capturekey = e.capturekey,
        a = _e$capturekey === void 0 ? " " : _e$capturekey,
        l = e.hide,
        _e$size = e.size,
        d = _e$size === void 0 ? "80px" : _e$size,
        _e$holdscale = e.holdscale,
        u = _e$holdscale === void 0 ? "1.35" : _e$holdscale,
        _e$borderscale = e.borderscale,
        f = _e$borderscale === void 0 ? "0.075" : _e$borderscale,
        _e$iconsize = e.iconsize,
        h = _e$iconsize === void 0 ? "60%" : _e$iconsize,
        _e$fxsize = e.fxsize,
        p = _e$fxsize === void 0 ? "250%" : _e$fxsize,
        _e$backgroundcolor = e.backgroundcolor,
        g = _e$backgroundcolor === void 0 ? "#ffffff" : _e$backgroundcolor,
        _e$iconcolor = e.iconcolor,
        $ = _e$iconcolor === void 0 ? "#000000" : _e$iconcolor,
        _e$gradientstop = e.gradientstop1,
        m = _e$gradientstop === void 0 ? "#15e8b5" : _e$gradientstop,
        _e$gradientstop2 = e.gradientstop2,
        v = _e$gradientstop2 === void 0 ? "#4fa1f9" : _e$gradientstop2,
        x = e.fxgradientstop1,
        w = e.fxgradientstop2,
        b = e.customcssurl;
    var y = !1,
        z = 0,
        E = [0, 0],
        M = [0, 0],
        _ = [1, 1],
        C = [0, 0],
        N = ot[c],
        D = null,
        B = 0,
        F = 0;

    var S = k(),
        L = function L(t, e) {
      S.dispatchEvent(new CustomEvent(t, {
        detail: e,
        composed: !0
      }));
    };

    var A;
    A = function A() {
      n(12, M = [1, 0]);
      var t = null;

      var e = function e() {
        B = F, F = new Date().getTime();
        var i = F - (B || F);
        N.effect === et.Connecting && n(13, _[0] = .25 * Math.cos(F / 2500 * Math.PI * 2) + .25, _), N.effect === et.Busy && n(13, _[0] = .25 * Math.cos(F / 1e3 * Math.PI * 2) + .25, _), n(12, M = [M[0], P(M[1], o ? M[0] : 0, .2, i)]), n(13, _ = [_[0], P(_[1], _[0], .08, i)]), n(14, C = [C[0], P(C[1], C[0], .08, i)]), n(11, E = [E[0] + 2.5, P(E[1], E[0], .05, i)]), t = requestAnimationFrame(e);
      };

      return e(), function () {
        return cancelAnimationFrame(t);
      };
    }, k().$$.on_mount.push(A);

    var R = function R(t) {
      t.preventDefault(), t.stopPropagation(), o && !y && (n(10, y = !0), z = Date.now(), T(), N.triggerFx === nt.Whirl && n(11, E[0] += 720, E), N.behaviour === tt.Click && null === D && (D = window.setTimeout(function () {
        n(14, C[0] = 0, C), D = null;
      }, 500)), S.onholdstart && S.onholdstart(), L(Y.holdstart));
    },
        I = function I() {
      if (y) {
        n(10, y = !1);
        var _t6 = {
          timeMs: Date.now() - z
        };
        T(), null !== D && window.clearTimeout(D), S.onholdend && S.onholdend(_t6), L("holdend", _t6);
      }
    },
        P = function P(t, e, n, o) {
      return t * (1 - (n = Math.pow(n, 1e3 / 60 / o))) + e * n;
    },
        T = function T() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      void 0 !== navigator.vibrate && navigator.vibrate(t);
    };

    return t.$$set = function (t) {
      "icon" in t && n(22, c = t.icon), "capturekey" in t && n(23, a = t.capturekey), "hide" in t && n(24, l = t.hide), "size" in t && n(0, d = t.size), "holdscale" in t && n(25, u = t.holdscale), "borderscale" in t && n(26, f = t.borderscale), "iconsize" in t && n(1, h = t.iconsize), "fxsize" in t && n(2, p = t.fxsize), "backgroundcolor" in t && n(3, g = t.backgroundcolor), "iconcolor" in t && n(4, $ = t.iconcolor), "gradientstop1" in t && n(5, m = t.gradientstop1), "gradientstop2" in t && n(6, v = t.gradientstop2), "fxgradientstop1" in t && n(7, x = t.fxgradientstop1), "fxgradientstop2" in t && n(8, w = t.fxgradientstop2), "customcssurl" in t && n(9, b = t.customcssurl);
    }, t.$$.update = function () {
      16777216 & t.$$.dirty[0] && (o = void 0 === l || "false" === l), 67108864 & t.$$.dirty[0] && n(17, i = "" + 46 * f), 67108864 & t.$$.dirty[0] && n(16, r = 46 - 23 * f), 33554432 & t.$$.dirty[0] && (s = u), 4195328 & t.$$.dirty[0] && function (t, e) {
        switch (n(15, N = ot[e]), n(12, M[0] = t ? s : 1, M), n(14, C[0] = t || e == Q.Recording ? 1 : 0, C), N.icon) {
          case Z.MicActive:
          case Z.Mic:
          case Z.Denied:
          case Z.Error:
            n(13, _[0] = 1, _);
        }
      }(y, c);
    }, [d, h, p, g, $, m, v, x, w, b, y, E, M, _, C, N, r, i, R, I, function (t) {
      a && t.key === a && (document.hasFocus() && document.activeElement !== document.body && document.activeElement !== document.documentElement && document.activeElement || null || (t.repeat ? (t.preventDefault(), t.stopPropagation()) : R(t)));
    }, function (t) {
      t.key === a && I();
    }, c, a, l, u, f, function () {
      return y;
    }];
  }

  var xt = /*#__PURE__*/function (_O) {
    _inherits(xt, _O);

    function xt(t) {
      var _this5;

      _classCallCheck(this, xt);

      _this5 = _possibleConstructorReturn(this, _getPrototypeOf(xt).call(this)), _this5.shadowRoot.innerHTML = "<style>main{text-align:left;position:relative;pointer-events:auto;cursor:pointer;border-radius:50%;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none !important;-webkit-user-select:none !important}</style>", j(_assertThisInitialized(_assertThisInitialized(_this5)), {
        target: _this5.shadowRoot,
        props: w(_this5.attributes),
        customElement: !0
      }, vt, mt, s, {
        icon: 22,
        capturekey: 23,
        hide: 24,
        size: 0,
        holdscale: 25,
        borderscale: 26,
        iconsize: 1,
        fxsize: 2,
        backgroundcolor: 3,
        iconcolor: 4,
        gradientstop1: 5,
        gradientstop2: 6,
        fxgradientstop1: 7,
        fxgradientstop2: 8,
        customcssurl: 9,
        isbuttonpressed: 27
      }, null, [-1, -1]), t && (t.target && d(t.target, _assertThisInitialized(_assertThisInitialized(_this5)), t.anchor), t.props && (_this5.$set(t.props), S()));
      return _this5;
    }

    _createClass(xt, [{
      key: "icon",
      get: function get() {
        return this.$$.ctx[22];
      },
      set: function set(t) {
        this.$$set({
          icon: t
        }), S();
      }
    }, {
      key: "capturekey",
      get: function get() {
        return this.$$.ctx[23];
      },
      set: function set(t) {
        this.$$set({
          capturekey: t
        }), S();
      }
    }, {
      key: "hide",
      get: function get() {
        return this.$$.ctx[24];
      },
      set: function set(t) {
        this.$$set({
          hide: t
        }), S();
      }
    }, {
      key: "size",
      get: function get() {
        return this.$$.ctx[0];
      },
      set: function set(t) {
        this.$$set({
          size: t
        }), S();
      }
    }, {
      key: "holdscale",
      get: function get() {
        return this.$$.ctx[25];
      },
      set: function set(t) {
        this.$$set({
          holdscale: t
        }), S();
      }
    }, {
      key: "borderscale",
      get: function get() {
        return this.$$.ctx[26];
      },
      set: function set(t) {
        this.$$set({
          borderscale: t
        }), S();
      }
    }, {
      key: "iconsize",
      get: function get() {
        return this.$$.ctx[1];
      },
      set: function set(t) {
        this.$$set({
          iconsize: t
        }), S();
      }
    }, {
      key: "fxsize",
      get: function get() {
        return this.$$.ctx[2];
      },
      set: function set(t) {
        this.$$set({
          fxsize: t
        }), S();
      }
    }, {
      key: "backgroundcolor",
      get: function get() {
        return this.$$.ctx[3];
      },
      set: function set(t) {
        this.$$set({
          backgroundcolor: t
        }), S();
      }
    }, {
      key: "iconcolor",
      get: function get() {
        return this.$$.ctx[4];
      },
      set: function set(t) {
        this.$$set({
          iconcolor: t
        }), S();
      }
    }, {
      key: "gradientstop1",
      get: function get() {
        return this.$$.ctx[5];
      },
      set: function set(t) {
        this.$$set({
          gradientstop1: t
        }), S();
      }
    }, {
      key: "gradientstop2",
      get: function get() {
        return this.$$.ctx[6];
      },
      set: function set(t) {
        this.$$set({
          gradientstop2: t
        }), S();
      }
    }, {
      key: "fxgradientstop1",
      get: function get() {
        return this.$$.ctx[7];
      },
      set: function set(t) {
        this.$$set({
          fxgradientstop1: t
        }), S();
      }
    }, {
      key: "fxgradientstop2",
      get: function get() {
        return this.$$.ctx[8];
      },
      set: function set(t) {
        this.$$set({
          fxgradientstop2: t
        }), S();
      }
    }, {
      key: "customcssurl",
      get: function get() {
        return this.$$.ctx[9];
      },
      set: function set(t) {
        this.$$set({
          customcssurl: t
        }), S();
      }
    }, {
      key: "isbuttonpressed",
      get: function get() {
        return this.$$.ctx[27];
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ["icon", "capturekey", "hide", "size", "holdscale", "borderscale", "iconsize", "fxsize", "backgroundcolor", "iconcolor", "gradientstop1", "gradientstop2", "fxgradientstop1", "fxgradientstop2", "customcssurl", "isbuttonpressed"];
      }
    }]);

    return xt;
  }(O);

  customElements.get("holdable-button") ? console.warn("Skipping re-defining customElement holdable-button") : customElements.define("holdable-button", xt);
});